import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { AdminProgressReviewBlurRequest } from '../../contracts/review'

export const getAdminProgressReviewBlurRequest = asBuilder((): AdminProgressReviewBlurRequest => {
  return {
    progressId: faker.number.int(),
    photos: faker.helpers.multiple(() => ({
      url: faker.image.url(),
      blurred: faker.datatype.boolean(),
    })),
  }
})
